module.exports = __webpack_public_path__ + "static/media/heading-divider-small.d311e42e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/heading-divider-small.svg
// module id = 195
// module chunks = 0